module.exports = __webpack_public_path__ + "static/media/excel-poster.6cb200b0.jpg";